import React, { useState } from 'react'
import {
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  LinearProgress
} from '@mui/material'

import { useSelector, useDispatch } from 'react-redux'
import { forgotPassword } from '../../actions/userActions'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const dispatch = useDispatch()
  const { error, msg, loading } = useSelector(state => state.userState)

  const onSubmit = e => {
    e.preventDefault()
    dispatch(forgotPassword(email))
  }

  return (
    <Card sx={{ maxWidth: 650, mx: 'auto', mt: 5 }}>
      {loading && <LinearProgress />}
      <CardContent sx={{ p: 3 }}>
        <Typography variant='h6' sx={{ mb: 2 }}>Reset your password</Typography>
        <Typography>Enter your account email address and we will send you a password reset link.</Typography>
        <form onSubmit={onSubmit}>
          {error && <Alert severity='error' sx={{ mt: 1 }}>{error}</Alert>}
          {msg && <Alert severity='info' sx={{ mt: 1 }}>{msg}</Alert>}
          <TextField
            label='Email'
            fullWidth
            sx={{ my: 3 }}
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <Button type='submit' variant='contained' fullWidth>Submit</Button>
        </form>
      </CardContent>
    </Card>
  )
}

export default ForgotPassword